/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import metrics from 'modules/metrics';
import container from 'modules/section-content';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import InteractiveWidget from 'modules/interactive-widget';
import React from 'react';
import { render } from 'react-dom';
import { LockPlayground } from 'components';
import layout from './views/main.pug';
import metadata from './data/metadata.json';

/**
 * Routes
 */
export default function register() {
  page('/jp/', initial, loadScripts, snippets);
  page.exit('/jp/', exit);
  page.exit('/jp/signup', exit);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(layout()) })
  };
  container.render(renderOptions);

  return next();
}

/**
 * Load required scripts
 */
function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('//cdn2.auth0.com/website/custom/lock-passwordless-2.min.js', 'Auth0LockPasswordless', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/homepage/vendor/tooltips-a344d1455d.min.js', '$.fn.tooltip', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/homepage/vendor/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.end(next);
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  renderLockPlayground();

  popoverEmbedWistia();

  const $ = window.$;
  const carouselControls = $('[data-slide="prev"], [data-slide="next"], [data-slide-to]');

  const lockPasswordless = new InteractiveWidget(
    '#interactive-passwordless-section',
    'passwordless',
    'interactive-passwordless'
  );

  setCarouselHeight();
  $(window).on('resize', setCarouselHeight);

  // Load Roboto Mono Font
  loadRobotoFont();

  // Add css animation
  $('.carousel').bind('slide.bs.carousel', () => {
    $('.slide-2 .illustration-aircraft, .slide-2 .illustration-phone, .slide-2 .sdks').addClass(
      'animated'
    );
  });

  // Track scroll until the widget is reached, then fire metrics event and unbind scroll
  $(window).on('scroll', trackScrollHomepage);

  // Track when carousel controls are clicked
  carouselControls.on('click', () => {
    metrics.lib().track('click:carousel');
  });

  // Init interactive locks
  lockPasswordless.init();

  $('#carousel').swiperight(function swiperight() {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function swipeleft() {
    $(this).carousel('next');
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('a[data-toggle="tab"]').on('shown.bs.tab', () => {
    if (!lockPasswordless.fieldsReady) {
      lockPasswordless.initFields();
    }
  });

  next();
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  const el = document.getElementById('playground-next');

  render(<LockPlayground />, el);
}

/**
 *  load popover embeds wistia Video
 */
function popoverEmbedWistia() {
  const popoverOptions =
    'autoPlay=true&controlsVisibleOnLoad=true&popover=true&version=v1&videoHeight=360&videoWidth=640';
  const hrefValue = `//fast.wistia.com/embed/iframe/fu7ww3h1yx?${popoverOptions}`;
  const addAttr = () => {
    $('#wistia-popover').on('click', false);
    return $('.video-btn').attr('href', hrefValue);
  };

  $.when(addAttr()).done(() => {
    $.getScript('//fast.wistia.com/static/popover-v1.js');
  });
}

/**
* Set carousel height
*/
function setCarouselHeight() {
  const $ = window.$;
  const windowHeight = $(window).height();
  const headerHeight = $('.site-header-v2').outerHeight(true);
  const customersHeight = $('.customers').outerHeight();
  $('.carousel').height(windowHeight - headerHeight - customersHeight);
}

/**
 * Load Roboto font
 */
function loadRobotoFont() {
  window.WebFontConfig = {
    google: { families: ['Roboto+Mono:400,300,500,700:latin'] }
  };
  (function webfont() {
    const wf = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];
    wf.src = `${document.location.protocol === 'https:' ? 'https' : 'http'}://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js`;
    wf.type = 'text/javascript';
    wf.async = 'true';
    s.parentNode.insertBefore(wf, s);
  })();
}

/**
 * Track scroll on homepage when widget is reached
 */
function trackScrollHomepage() {
  const $ = window.$;
  const widgetOffsetTop = $('#playground-next').parent().parent().offset().top;

  if ($(window).scrollTop() >= widgetOffsetTop) {
    metrics.lib().track('scroll:homepage');
    $(window).off('scroll', trackScrollHomepage);
  }
}

/**
 * Unsubscribe from window events
 */
function exit(ctx, next) {
  const $ = window.$;
  $(window).off('scroll', trackScrollHomepage);
  $(window).off('resize', setCarouselHeight);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/client.js